import React from "react";
import { useInView } from "react-intersection-observer";

// CSS
import * as styles from "./DiabetesReversal.module.css";

const DiabetesReversalComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  return (
    <>
      <div
        ref={ref}
        className={`container-fluid scroll_animate ${inView && "inview"} ${
          styles.diabConsLp__diabRev__cont
        }`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.diabConsLp__diabRev__hdng}>
              <h3>Yes,Diabetes Reversal Is Possible</h3>
              <p>
                With our revolutionary technology - Whole Body Digital Twin it’s
                possible to live a Diabetes-free life in just 4 phases
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-3 col-lg-3">
            <div className={styles.diabConsLp__diabRev__card1}>
              <h3>Phase 1</h3>
              <p>Reducing sugar levels, getting HbA1C below 6.5</p>
            </div>
          </div>
          <div className="col-12 col-md-3 col-lg-3">
            <div className={styles.diabConsLp__diabRev__card2}>
              <h3>Phase 2</h3>
              <p>
                Treating chronic conditions like BP, Cholesterol and Obesity
              </p>
            </div>
          </div>
          <div className="col-12 col-md-3 col-lg-3">
            <div className={styles.diabConsLp__diabRev__card3}>
              <h3>Phase 3</h3>
              <p>Improving Organ Health - Liver, Kidney & Pancreas</p>
            </div>
          </div>
          <div className="col-12 col-md-3 col-lg-3">
            <div className={styles.diabConsLp__diabRev__card4}>
              <h3>Phase 4</h3>
              <p>Beta cells regeneration leading to Diabetes Reversal</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiabetesReversalComponent;
